/* Find your fibre quiz v2 - ported from QuizScreenV2.jsx. Q1 routes to a
   path ("relief" = Sensitive blend, "stability" = Daily blend); Q2 and Q3
   come from that path and each answer has a "Good to know" note; Q4 is a
   yes. The result copy is assembled from the answers in answerFor(),
   mirroring the design's own function of the same name.

   "Good to know" is education only (no product names, no links) - the
   suggestion card at the end is where myota appears. */
(function () {
  'use strict';

  var Q1 = {
    id: 'goal', q: 'What would you most like help with?', sub: 'Pick the one that matters most right now.',
    a: [
      { label: 'My tummy is sensitive and often uncomfortable', path: 'relief', key: 'sensitive' },
      { label: 'I’m not as regular as I’d like', path: 'relief', key: 'regular' },
      { label: 'Looking after my heart, cholesterol and blood sugar', path: 'stability', key: 'heart' },
      { label: 'Feeling steadier day to day, with more focus', path: 'stability', key: 'focus' }
    ]
  };

  function key(ans) { return ans.goal != null ? Q1.a[ans.goal].key : 'sensitive'; }

  var PATHS = {
    relief: [
      { id: 'tried', q: 'Have you tried a fibre supplement before?', a: [
        { label: 'Yes, and it didn’t agree with me', info: function () { return 'That’s really common. Many fibre supplements use a single fibre, such as psyllium or inulin, in a large dose. Some fibres ferment quickly and produce gas, which a sensitive gut will notice. The type of fibre and how fast you build up both make a difference.'; } },
        { label: 'Yes, it helped a little', info: function () { return 'Different fibres feed different gut bacteria. A single fibre only feeds the bacteria that happen to like it, so a mix of fibre types tends to reach more of your microbiome.'; } },
        { label: 'No, this would be my first', info: function () { return 'Fibre works best when you build up slowly. A sudden jump can cause wind or discomfort while your gut bacteria adjust, so start small, increase over a week or two, and drink plenty of water.'; } }
      ] },
      { id: 'foods', q: 'Do certain foods seem to set your tummy off?', a: [
        { label: 'Yes, and I’ve tried or been told about low FODMAP', info: function () { return 'FODMAPs are short-chain carbohydrates that aren’t well absorbed in the small intestine. When they reach the large intestine, gut bacteria ferment them quickly, which can cause wind and discomfort in a sensitive gut. Common sources include onion, garlic, wheat, beans and some fruits. Some fibres, like inulin and FOS, are FODMAPs too.'; } },
        { label: 'Yes, but I’m not sure which ones', info: function () { return 'Lots of people react to certain foods without knowing which. FODMAPs, a group of fermentable carbohydrates in foods like onion, garlic, beans and some fruits, are a common trigger for sensitive tummies. A food and symptom diary, or a registered dietitian, can help you pinpoint yours.'; } },
        { label: 'Not really', info: function (ans) {
          return key(ans) === 'regular'
            ? 'If food doesn’t seem to be the trigger, the amount of fibre might be. Most UK adults eat around 16g a day against a recommended 30g. Fibre adds bulk and holds on to water, which helps keep stools soft and regular.'
            : 'Discomfort isn’t always about specific foods. How much fibre you eat matters too: most UK adults get around 16g a day against a recommended 30g, and your gut bacteria rely on fibre to do their job.';
        } }
      ] }
    ],
    stability: [
      { id: 'intake', q: 'How much fibre do you think you eat a day?', a: [
        { label: 'Less than 15g', info: function () { return 'You’re not alone. Most UK adults eat around 16g a day, roughly half the recommended 30g, and fewer than 1 in 20 of us reach it.'; } },
        { label: 'Around 20g', info: function () { return 'That’s a little above the UK average of around 16g, but still about 10g short of the recommended 30g. Fewer than 1 in 20 of us reach 30g.'; } },
        { label: '30g or more', info: function () { return 'That puts you in a small group: fewer than 1 in 20 UK adults reach the recommended 30g a day. Amount is only half the picture, though. The next question is about variety.'; } },
        { label: 'I’ve no idea', info: function () { return 'Most people don’t, because nobody teaches us to count fibre. As a guide, a bowl of porridge has around 4g and a cup of cooked lentils around 8g. Most UK adults eat around 16g a day against a recommended 30g.'; } }
      ] },
      { id: 'plants', q: 'How many different plants do you eat in a week?', sub: 'Fruit, veg, grains, beans, nuts, seeds, herbs and spices all count.', a: [
        { label: 'Fewer than 10', info: function () { return 'Different fibres feed different gut bacteria, so variety matters as much as amount. The guidance is 30 different plants a week. Easy wins: mixed beans instead of one kind, seeds on your breakfast, and more herbs and spices.'; } },
        { label: '10 to 20', info: function () { return 'A good base. Different fibres feed different gut bacteria, and the guidance is 30 different plants a week. Herbs, spices, nuts and seeds all count, so a few small swaps can get you there.'; } },
        { label: 'Around 30 or more', info: function (ans) {
          return ans.intake === 2
            ? 'That’s the target, on both counts. Plenty of fibre from a wide range of plants gives your gut bacteria a lot to work with. For most people, the hard part is keeping it up through busy weeks, travel and eating out.'
            : 'That’s the target. Eating 30 different plants a week gives your gut bacteria a wide range of fibres to ferment, which supports a diverse microbiome.';
        } },
        { label: 'I’ve never counted', info: function () { return 'Try it for a week. Fruit, veg, wholegrains, beans, nuts, seeds, herbs and spices all count, and the guidance is 30 different plants. Most people are surprised by how few they eat.'; } }
      ] }
    ]
  };

  var YES = [{ label: 'Yes, show me my answer' }, { label: 'Yes, but I have a question first' }];

  function q4(path, ans) {
    var q;
    if (path === 'relief') {
      q = ans.tried === 0 ? 'Would you like to try fibre again, gently, starting with just half a scoop a day?'
        : key(ans) === 'regular' ? 'Would you like to feel more regular, with just one flavourless scoop a day?'
        : 'Would you like to give your gut the gentle fibre it’s been missing, with one flavourless scoop a day?';
    } else {
      var amountOk = ans.intake === 2, varietyOk = ans.plants === 2;
      q = amountOk && varietyOk ? 'Would you like an easy way to keep that up on busy days, just by stirring one scoop into your morning coffee or porridge?'
        : amountOk ? 'Would you like to add more fibre variety to your day, just by stirring one scoop into your morning coffee or porridge?'
        : 'Would you like to close your fibre gap and support your heart and gut, just by stirring one scoop into your morning coffee or porridge?';
    }
    return { id: 'yes', q: q, a: YES };
  }

  function answerFor(path, ans) {
    var k = key(ans);
    var going = [], can = [], cant = [], why = [];
    if (path === 'relief') {
      var foodsTrigger = ans.foods === 0 || ans.foods === 1;
      going.push(k === 'regular'
        ? 'Irregularity is often a sign your gut isn’t getting enough of the right fibre. Fibre adds bulk, holds on to water and helps keep things moving. When your gut bacteria ferment it, they make short-chain fatty acids that feed the cells lining your colon.'
        : 'A sensitive tummy can react to some foods, and to some fibres. The aim is to feed your gut bacteria without adding to the discomfort, which means choosing gentle fibres and building up slowly.');
      if (ans.tried === 0) going.push('Because fibre hasn’t agreed with you before, the type of fibre and a slow start matter most.');
      if (foodsTrigger) going.push('As certain foods set you off, it makes sense to choose fibre that’s low in FODMAPs, so the fibre itself doesn’t add to the problem.');
      why.push('Monash University Low FODMAP Certified™, with 5 gentle fibres');
      if (ans.tried === 0) why.push('Led by PHGG, a fibre that ferments slowly, with a half-scoop start');
      if (foodsTrigger) why.push('Fits alongside a low FODMAP diet');
      if (k === 'regular') why.push('Formulated to support regularity');
      why.push('Plus zinc, which contributes to normal immune function');
      why.push('Vegan, gluten free and flavourless');
      can = ['Feed the good bacteria you already have', k === 'regular' ? 'Support regular, comfortable bowel movements' : 'Give your gut fibre without the usual triggers', 'Help you get closer to 30g a day'];
      cant.push('Replace advice from your GP or dietitian');
      if (foodsTrigger) cant.push('Stop food triggers on its own. What you eat still matters');
      cant.push('Work overnight. Your gut needs time to adjust');
      return { going: going, can: can, cant: cant, why: why };
    }

    var amountOk = ans.intake === 2, varietyOk = ans.plants === 2;
    var varietyLow = ans.plants === 0 || ans.plants === 1;
    var optimiser = amountOk && varietyOk;
    if (optimiser) {
      going.push('You’re already doing what most people aren’t: around 30g of fibre a day from a wide range of plants. Your gut bacteria are well fed.');
      going.push('At this point the challenge is consistency. Busy weeks, travel and eating out make it hard to hit 30g every day, and your gut bacteria do best on a steady supply.');
    } else {
      going.push(amountOk ? 'You’re already reaching 30g a day, which fewer than 1 in 20 people do.'
        : ans.intake === 0 ? 'You’re likely eating about half the recommended 30g of fibre a day, which is typical in the UK.'
        : ans.intake === 1 ? 'You’re likely around 10g a day short of the recommended 30g.'
        : 'Most UK adults eat around 16g of fibre a day, so there’s a good chance you’re short of the recommended 30g.');
      going.push(varietyOk ? 'You’re also eating a wide range of plants, so your gut bacteria have plenty of different fibres to work with.'
        : varietyLow ? (amountOk ? 'The gap is variety. Different fibres feed different bacteria, so the same few sources only feed some of them.' : 'Variety matters too: different fibres feed different bacteria.')
        : 'Counting your plants for a week is a quick way to see how varied your fibre is.');
      going.push('When your bacteria ferment fibre, they make short-chain fatty acids that travel round the body. Fibre also slows how quickly carbohydrate is absorbed and binds to cholesterol in the gut, helping remove it.');
    }
    if (optimiser) can.push('Give you a steady baseline on the days your diet slips');
    if (!amountOk) can.push('Help close the gap to 30g a day');
    if (!varietyOk && !optimiser) can.push('Add a range of fibre types in one go');
    can.push(k === 'focus' ? 'Provide zinc, which contributes to normal cognitive function' : 'Support healthy cholesterol and steadier blood sugar after meals');
    cant = optimiser
      ? ['Add a lot on days you already hit 30g from a varied diet', 'Replace medication or medical advice']
      : ['Replace a varied, plant-rich diet. Real food comes first', 'Replace medication or medical advice'];
    why.push('8 fibre types plus zinc in one scoop');
    why.push(k === 'focus' ? 'Zinc contributes to normal cognitive function' : 'Formulated to support healthy cholesterol and blood sugar');
    if (optimiser) why.push('An easy daily baseline for busy weeks');
    why.push('Gluten free and flavourless, in coffee, porridge or water');
    return { going: going, can: can, cant: cant, why: why };
  }

  function escapeHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function listHtml(items, icon) {
    return items.map(function (x) { return '<li><span class="quiz__list-icon">' + icon + '</span>' + escapeHtml(x) + '</li>'; }).join('');
  }

  function restartAnim(el) {
    el.classList.remove('is-animating');
    void el.offsetWidth;
    el.classList.add('is-animating');
  }

  function initQuiz(root) {
    var assets = window.MyotaQuizAssets || { microbes: [], icons: {} };
    var el = function (sel) { return root.querySelector(sel); };
    var questionPanel = el('[data-quiz-question]');
    var resultPanel = el('[data-quiz-result]');
    var progress = el('[data-quiz-progress]');
    var bars = Array.prototype.slice.call(progress.children);
    var optionsWrap = el('[data-quiz-options]');
    var info = el('[data-quiz-info]');
    var backWrap = el('[data-quiz-back-wrap]');

    var step = 0, ans = {}, done = false;

    function path() { return ans.goal != null ? Q1.a[ans.goal].path : 'relief'; }
    function steps() { var p = PATHS[path()]; return [Q1, p[0], p[1], q4(path(), ans)]; }
    function top() { window.scrollTo({ top: 0, behavior: 'smooth' }); }

    function renderProgress(total) {
      bars.forEach(function (bar, i) {
        bar.className = done || i < step ? 'is-done' : i === step ? 'is-current' : '';
      });
      progress.setAttribute('aria-label', done ? 'Quiz complete' : 'Question ' + (step + 1) + ' of ' + total);
    }

    function renderQuestion() {
      var all = steps();
      var cur = all[step];
      var picked = ans[cur.id];
      el('[data-quiz-count]').textContent = 'Question ' + (step + 1) + ' of ' + all.length;
      el('[data-quiz-q]').textContent = cur.q;
      var sub = el('[data-quiz-sub]');
      sub.hidden = !cur.sub;
      sub.textContent = cur.sub || '';
      optionsWrap.innerHTML = cur.a.map(function (o, i) {
        var selected = picked === i;
        var microbe = assets.microbes[(i + step) % assets.microbes.length];
        return '<button type="button" class="quiz__opt' + (selected ? ' is-selected' : '') + '" aria-pressed="' + selected + '" data-quiz-opt="' + i + '">' +
          '<span class="quiz__opt-icon"><img src="' + microbe + '" width="26" height="26" alt=""></span>' +
          '<span class="quiz__opt-label">' + escapeHtml(o.label) + '</span>' +
          '<span class="quiz__opt-mark">' + (selected ? assets.icons.check : assets.icons.chevron) + '</span>' +
        '</button>';
      }).join('');
      var note = picked != null && cur.a[picked].info ? cur.a[picked].info(ans) : null;
      info.hidden = !note;
      if (note) el('[data-quiz-info-text]').textContent = note;
      backWrap.hidden = step === 0;
      renderProgress(all.length);
    }

    function renderResult() {
      var p = path();
      var r = answerFor(p, ans);
      var wantsQ = ans.yes === 1;
      el('[data-quiz-going]').innerHTML = r.going.map(function (t) { return '<p>' + escapeHtml(t) + '</p>'; }).join('');
      el('[data-quiz-can]').innerHTML = listHtml(r.can, assets.icons.checkSm);
      el('[data-quiz-cant]').innerHTML = listHtml(r.cant, assets.icons.closeSm);
      Array.prototype.forEach.call(root.querySelectorAll('[data-quiz-rec]'), function (rec) {
        var match = rec.getAttribute('data-quiz-rec') === p;
        rec.hidden = !match;
        if (match) rec.querySelector('[data-quiz-why]').innerHTML = listHtml(r.why, assets.icons.checkSm);
      });
      el('[data-quiz-contact]').classList.toggle('is-question', wantsQ);
      el('[data-quiz-contact-text]').textContent = wantsQ
        ? 'Got a question? Our team of dietitians and scientists will answer it straight.'
        : 'Taking medication or managing a diagnosed condition? Check with your GP or pharmacist first.';
      el('[data-quiz-contact-btn]').textContent = wantsQ ? 'Ask us' : 'Contact us';
    }

    function render() {
      questionPanel.hidden = done;
      resultPanel.hidden = !done;
      el('[data-quiz-mark]').textContent = done ? '.' : '?';
      el('[data-quiz-intro]').textContent = done
        ? 'Here’s what we think is going on, and what to expect.'
        : 'Four quick questions. No email needed, and no wrong answers.';
      if (done) {
        renderResult();
        renderProgress(4);
        restartAnim(resultPanel);
      } else {
        renderQuestion();
      }
    }

    function next() {
      if (step < steps().length - 1) {
        step++;
        render();
        restartAnim(questionPanel);
      } else {
        done = true;
        render();
        document.dispatchEvent(new CustomEvent('myota:quiz-complete', {
          detail: { result: path() === 'relief' ? 'gut' : 'metabolic' }
        }));
      }
      top();
    }

    function choose(i) {
      var all = steps();
      var cur = all[step];
      if (ans[cur.id] !== i) {
        all.slice(step + 1).forEach(function (st) { delete ans[st.id]; });
      }
      if (cur.id === 'goal' && ans.goal != null && Q1.a[ans.goal].path !== Q1.a[i].path) {
        delete ans.tried; delete ans.foods; delete ans.intake; delete ans.plants;
      }
      ans[cur.id] = i;
      renderQuestion();
      if (!cur.a[i].info) {
        window.setTimeout(next, 160);
      } else {
        restartAnim(info);
      }
    }

    root.addEventListener('click', function (event) {
      var opt = event.target.closest('[data-quiz-opt]');
      if (opt) { choose(parseInt(opt.getAttribute('data-quiz-opt'), 10)); return; }
      if (event.target.closest('[data-quiz-next]')) { next(); return; }
      if (event.target.closest('[data-quiz-back]')) {
        if (step > 0) { step--; render(); restartAnim(questionPanel); }
        return;
      }
      if (event.target.closest('[data-quiz-retake]')) {
        ans = {}; step = 0; done = false;
        render();
        restartAnim(questionPanel);
        top();
      }
    });

    render();
    document.dispatchEvent(new CustomEvent('myota:quiz-start'));
  }

  document.querySelectorAll('[data-quiz]').forEach(initQuiz);
})();
